import React from "react";
import PropTypes from "prop-types";

import { useClassName } from "@travpro/hooks";
import i18n from "i18n-react";

import ContentHeader from "components/ContentHeader";
import Modal from "components/Modal";
import IndexSearch from "components/SearchModal/IndexSearch";

import { algolia } from "settings";

/**
 * @typedef {object} SearchModalProps
 * @property {boolean} show Whether to show the modal or not.
 * @property {Function} onHide Function to call when the modal is closed.
 * @property {string} [query=''] The current search query. Defaults to an empty string. Default is `''`
 * @property {Function} [updateQuery=null] A function to call when the search query is updated. Gets passed the current
 *   query. Default is `null`
 */

/**
 * A controlled search-modal component using Algolia search toolling, displayed inside of a Modal component.
 *
 * @param {SearchModalProps} props Props
 * @returns {JSX.Element} SearchModal component with children.
 */

const SearchModal = ({ show, onHide, query = "", updateQuery = null }) => {
  const c = useClassName("search-modal");
  const { id: searchId, searchKey, hitsPerPage, attributesToSnippet } = algolia;

  return (
    <div {...c()}>
      <Modal id="search-modal__index" show={!!show} onHide={onHide} bgClose>
        <div {...c()}>
          <ContentHeader header={i18n.translate("nav.search")} />
          <IndexSearch
            algoliaId={searchId}
            algoliaSearchKey={searchKey}
            hitsPerPage={hitsPerPage}
            attributesToSnippet={attributesToSnippet}
            onHide={onHide}
            defaultQuery={query}
            onQuery={updateQuery}
            salesCompanion
            pages
          />
        </div>
      </Modal>
    </div>
  );
};

SearchModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  query: PropTypes.string,
  updateQuery: PropTypes.func,
};

export default SearchModal;
